import { Directive } from '@angular/core';

@Directive({
  selector: '[snButtonLabel], sn-button-label',
  exportAs: 'snButtonLabel',
  host: {
    class: 'sn-button__label',
  },
})
export class SnButtonLabelDirective {
  constructor() {}
}
